import * as React from "react";
import moment from "moment";
import api from "../../../api";
import { LeadRequirement } from "../../../core/api/models/requirement";
import BlankProPic from "../../../styles/images/no-user-sm.png";

const VersionList: React.FunctionComponent<{
  versions?: LeadRequirement[];
  onButtonAction: (id: string, action: string) => void;
  onCompare: (id: string) => void;
  onVersionEdit: (id: string) => void;
  canRequirementStatusApprove: boolean;
  canRequirementStatusReject: boolean;
}> = (props) => {
  const decodeHtmlEntities = (html: string) => {
    const textarea = document.createElement("textarea");
    textarea.innerHTML = html;
    return textarea.value;
  };
  return (
    <>
      <div className="">
        <div className="font-base font-weight-semibold mb-2 pb-1">
          Requirement Versions
        </div>
        <div className="table-responsive">
          <table className="table table-bordered w-100">
            <tr>
              <th className="font-sm font-weight-semibold">Created By</th>
              <th
                className="font-sm font-weight-semibold"
                style={{ maxWidth: "350px", width: "350px" }}
              >
                Requirement Title
              </th>
              <th
                className="font-sm font-weight-semibold"
                style={{ width: "85px", minWidth: "85px", maxWidth: "85px" }}
              >
                Version
              </th>
              <th className="font-sm font-weight-semibold">
                Requested / Approved by
              </th>
              <th className="font-sm font-weight-semibold">Version Status</th>
              <th className="font-sm font-weight-semibold">Action</th>
            </tr>
            {props?.versions?.map((version) => {    
              
              const projectTypes = `${version?.projectTypeDetails?.map((pType: any) => pType.propertyTypeName)}, ", "`;
              return (
                <tr>
                  <td className="font-sm font-weight-semibold">
                    <div className="d-flex align-items-center">
                      <img
                        src={version?.createdBy?.avatar?.location ?? BlankProPic}
                        alt="created by"
                        width={25}
                        height={25}
                        className="img-cover rounded-circle mr-2"
                      />
                      {version.createdBy?.name}
                    </div>
                    <div>
                      {version.createdBy && (
                        <span className="text-gray-600">On</span>
                      )}{" "}
                      {moment(version?.createdAt).format("DD MMM YYYY hh:mm A")}{" "}
                    </div>
                  </td>
                  <td className="font-sm font-weight-semibold">
                    {version?.cityDetails?.cityName}
                    {(version?.microMarketDetails?.length ||
                      version?.propertyTypeDetails?.propertyTypeName ||
                      projectTypes) &&
                      ", "}
                    {version.microMarketDetails
                      ?.map((x) => x.cityZoneName)
                      .join(",")}{" "}
                    {(version?.propertyTypeDetails?.propertyTypeName ||
                      projectTypes) &&
                      ", "}
                    {version?.propertyTypeDetails?.propertyTypeName &&
                      decodeHtmlEntities(
                        version?.propertyTypeDetails?.propertyTypeName
                      )}
                    {projectTypes && ", "}
                    {projectTypes &&
                      decodeHtmlEntities(
                        projectTypes
                      )}
                  </td>
                  <td className="font-sm font-weight-semibold">
                    V{version.versionNumber}
                  </td>
                  <td className="font-sm font-weight-semibold">
                    {version?.createdBy?.name && (
                      <>
                        <div className="d-flex align-items-center">

                          Requested by{" "}
                          <img
                            src={version?.createdBy?.avatar?.location ?? BlankProPic}
                            alt="created by"
                            width={25}
                            height={25}
                            className="img-cover rounded-circle mx-2"
                          />
                          {version?.createdBy?.name}
                        </div>
                        <div>
                          <span className="text-gray-600">On</span>{" "}
                          {moment(version?.createdAt).format(
                            "DD MMM YYYY hh:mm A"
                          )}{" "}
                        </div>
                      </>
                    )}
                    {version?.approvedBy && (
                      <>
                        <div className="d-flex align-items-center">
                          Approved by{" "}
                          <img
                            src={version?.approvedBy?.avatar?.location ?? BlankProPic}
                            alt="created by"
                            width={25}
                            height={25}
                            className="img-cover rounded-circle mx-2"
                          />
                          {version?.approvedBy?.name}
                        </div>
                        <div>
                          <span className="text-gray-600">On</span>{" "}
                          {moment(version?.approvedAt).format(
                            "DD MMM YYYY hh:mm A"
                          )}{" "}
                        </div>
                      </>
                    )}

                    {version?.rejectedBy && (
                      <>
                        <div className="d-flex align-items-center">
                          Rejected by{" "}
                          {/* <img
                            src={require(`../../assets/images/color-noimage.png`)}
                            alt="created by"
                            width={25}
                            height={25}
                            className="img-cover rounded-circle mx-2"
                          /> */}
                          {version?.rejectedBy?.name}
                        </div>
                        <div>
                          <span className="text-gray-600">On</span>{" "}
                          {moment(version?.rejectedAt).format(
                            "DD MMM YYYY hh:mm A"
                          )}{" "}
                        </div>
                      </>
                    )}
                  </td>
                  <td className="font-sm font-weight-semibold">
                    {version?.status
                      ? version?.status.charAt(0).toUpperCase() +
                      version?.status.slice(1)
                      : ""}
                  </td>
                  <td style={{ whiteSpace: "nowrap" }}>
                    {version.status === "pending" ? (
                      <>
                        {props.canRequirementStatusReject && <button
                          className="btn btn-outline-primary p-2 rounded font-xs font-weight-semibold mr-2"
                          onClick={() =>
                            props.onButtonAction(version?._id, "Reject")
                          }
                        >
                          Reject
                        </button>}
                        {props.canRequirementStatusApprove && <button
                          className="btn btn-outline-primary p-2 rounded font-xs font-weight-semibold mr-2"
                          onClick={() =>
                            props.onButtonAction(version?._id, "Approve")
                          }
                        >
                          Approve
                        </button>}
                      </>
                    ) : (
                      version.status === "rejected" && (
                        <>
                          <button
                            className="btn btn-outline-primary p-2 rounded font-xs font-weight-semibold mr-2"
                            onClick={() =>
                              props.onButtonAction(version?._id, "Revoke")
                            }
                          >
                            Revoke
                          </button>
                        </>
                      )
                    )}
                    {version?.masterRequirementId && (
                      <button
                        className="btn btn-outline-primary p-2 rounded font-xs font-weight-semibold mr-2"
                        onClick={() => props.onCompare(version?._id)}
                      >
                        Compare
                      </button>
                    )}
                    <button
                      className="btn btn-outline-primary p-2 rounded font-xs font-weight-semibold"
                      onClick={() => props.onVersionEdit(version?._id)}
                    >
                      Edit
                    </button>
                  </td>
                </tr>
              );
            })}
          </table>
        </div>
      </div>
    </>
  );
};

export default VersionList;
